/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import HOSTBG from '@/assets/host_bg.png';
import NoPermission from '@/assets/main2.png';
import HostTip from './components/HostTip';
import { schemaEncrypt } from '@/api';
import { downloadApp, getQueryString } from '@/utils/common';
interface ForbidProps {
  meeting?: any;
}
export enum ERROE_CODE {
  IS_HOST_CODE = '570004',
  DISABLE_JOIN_MEETING = '511003',
}
const Forbid: React.FC<ForbidProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const errorCode = getQueryString('errorCode');
    const { formatMessage } = useIntl();
    const openPopo = () => {
      // pp.openPopoMessageSession({ account: 0, type: 0 });
      schemaEncrypt('meeting', { oper_id: window.$meetingId, oper_type: 'join' }).catch((err) => {
        if (err.errcode === 0 && err.data) {
          function jump() {
            const a = window.document.createElement('a');
            a.href = err.data;
            a.click();
          }
          try {
            jump();
          } catch (err) {
            console.warn('schema打开失败', err);
          }
        }
      });
    };
    return (
      <>
        {errorCode === ERROE_CODE.IS_HOST_CODE && (
          <HostTip
            img={HOSTBG}
            title={formatMessage({ id: 'youAreTheHost' })}
            subTitle={formatMessage({ id: 'useNetEasePOPOClient' })}
            btn={
              <div className={s.btn}>
                <span className={s.open} onClick={openPopo}>
                  {formatMessage({ id: 'openNetEasePOPOClient' })}
                </span>
                <span className={s.download} onClick={downloadApp}>
                  {formatMessage({ id: 'downLoadPopo' })}
                </span>
              </div>
            }
          />
        )}
        {errorCode === ERROE_CODE.DISABLE_JOIN_MEETING && (
          <HostTip
            img={NoPermission}
            title={formatMessage({ id: 'noMeetingAccess' })}
            subTitle={formatMessage({ id: 'contactMeetingOrganizer' }, { name: '' })}
          />
        )}
      </>
    );
  })
);
export default Forbid;
